import fourohfour from '../assets/404.svg';

export default function NoMatch() {
  return (
    <div style={{ padding: 10 }}>
      <img src={fourohfour} className="fourohfour"/>
    </div>
  );
}